import { useQuery } from 'react-query'
import { api } from '../../../../services/api'

export function useProductsProvider(fornecedor = '') {
  const fetchProducts = async () => {
    const params = {}
    if (fornecedor) {
      params.fornecedor = fornecedor
    }

    const response = await api.get('/site/v2/controle-crm/lista-produtos-spot', { params })
    return response.data
  }

  return useQuery(['produtos-fornecedor', fornecedor], fetchProducts, {
    staleTime: 1000 * 60 * 5, // 5 minutos
    refetchOnWindowFocus: false,
    retry: 2,
  })
}
